import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '../../../../../core/i18n';
import { BadgeModule } from '../../../../../shared/components/badge';
import { PriceFileCategoryBadgeComponent } from './price-file-category-badge.component';

@NgModule({
  declarations: [PriceFileCategoryBadgeComponent],
  imports: [CommonModule, I18nModule, BadgeModule],
  exports: [PriceFileCategoryBadgeComponent],
})
export class PriceFileCategoryBadgeModule {}
